var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollectible = function SvgCollectible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "collectible_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 47.58 36.63",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".collectible_svg__cls-1{fill:#35938b}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.97 36.63 47.44 12.5h-9.2zM0 12.5l20.47 24.13L9.2 12.5zM12.58 0H8.4L.18 9.69h9.17zM47.58 9.69 39.37 0h-4.18l3.22 9.69zM36.14 9.69 33.08 0h-7.96v9.69zM24.95 12.5v23.4l10.93-23.4zM11.56 12.5l10.91 23.35V12.5zM22.63 0H14.7l-3.07 9.69h11z",
    className: "collectible_svg__cls-1"
  })));
};
export default SvgCollectible;